
export { DossierModelModule } from './dossier-model.module';
export { DossierModelService } from './dossier-model.service';
export { DossierModelResolver } from './dossier-model.resolver';